import { render, staticRenderFns } from "./AgreementsHistoryItems.vue?vue&type=template&id=d882ad06&scoped=true"
import script from "./AgreementsHistoryItems.vue?vue&type=script&lang=js"
export * from "./AgreementsHistoryItems.vue?vue&type=script&lang=js"
import style0 from "./AgreementsHistoryItems.vue?vue&type=style&index=0&id=d882ad06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882ad06",
  null
  
)

export default component.exports